import React from 'react';
import './BulkActionToolbar.css';

/**
 * BulkActionToolbar Component
 * 
 * A toolbar that displays when items are selected, providing bulk action buttons
 * for managing multiple files and folders at once.
 * 
 * Requirements: 8.4
 * - Shows when items are selected
 * - Displays selected count
 * - Provides Select All, Clear Selection, Delete Selected, and Move Selected buttons
 * 
 * @param {Object} props - Component props
 * @param {number} props.selectedCount - Count of selected items
 * @param {function} props.onSelectAll - Callback for Select All button
 * @param {function} props.onClearSelection - Callback for Clear Selection button
 * @param {function} props.onDeleteSelected - Callback for Delete Selected button
 * @param {function} props.onMoveSelected - Callback for Move Selected button
 * @param {boolean} props.disabled - Whether actions are disabled (during operations)
 */
const BulkActionToolbar = ({ 
  selectedCount, 
  onSelectAll, 
  onClearSelection, 
  onDeleteSelected, 
  onMoveSelected,
  disabled = false
}) => {
  // Only render when items are selected
  if (selectedCount === 0) return null;
  
  return (
    <div className="bulk-action-toolbar" data-testid="bulk-action-toolbar">
      <span className="selection-info">
        {selectedCount} item{selectedCount !== 1 ? 's' : ''} selected
      </span>
      <div className="bulk-actions">
        <button 
          className="select-all-button"
          onClick={onSelectAll} 
          disabled={disabled}
          data-testid="select-all-button"
        >
          Select All
        </button>
        <button 
          className="clear-selection-button"
          onClick={onClearSelection} 
          disabled={disabled}
          data-testid="clear-selection-button"
        >
          Clear Selection
        </button>
        <button 
          className="delete-selected-button"
          onClick={onDeleteSelected} 
          disabled={disabled}
          data-testid="delete-selected-button"
        >
          Delete Selected
        </button>
        <button 
          className="move-selected-button"
          onClick={onMoveSelected} 
          disabled={disabled}
          data-testid="move-selected-button"
        >
          Move Selected
        </button>
      </div>
    </div>
  );
};

export default BulkActionToolbar;
